// src/components/HeaderTitle/HeaderTitle.jsx

import PropTypes from "prop-types";

export default function HeaderTitle({
  role = "Administrateur",
  title = "",
  subtitle = "",
  icon: Icon = null,
  align = "left",
  className = "",
}) {
  const alignment =
    align === "center"
      ? "text-center items-center"
      : align === "right"
      ? "text-right items-end"
      : "text-left items-start";

  return (
    <header
      className={`relative overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-6 ${className}`}
    >
      <div className="pointer-events-none absolute -right-14 -top-14 h-32 w-32 rounded-full bg-sky-400/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-16 h-36 w-36 rounded-full bg-orange-400/10 blur-3xl" />

      <div className={`relative flex flex-col ${alignment}`}>
        {Icon && (
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-950 text-white shadow-lg shadow-slate-950/10 dark:bg-white dark:text-slate-950">
            <Icon className="text-lg" />
          </div>
        )}

        <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-slate-400">
          {String(role).toUpperCase()}
        </p>

        <h1 className="mt-2 font-montserrat text-2xl font-bold uppercase tracking-tight text-slate-950 dark:text-white sm:text-3xl md:text-4xl">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-500 dark:text-slate-400">
            {subtitle}
          </p>
        )}
      </div>
    </header>
  );
}

HeaderTitle.propTypes = {
  role: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType,
  align: PropTypes.oneOf(["left", "center", "right"]),
  className: PropTypes.string,
};